import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-regal-dark">
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;

